import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";

// Redirects to staff login if not authenticated. Returns the auth context.
export function useRequireAuth(superadmin = false) {
  const navigate = useNavigate();
  const auth = useAuth();
  useEffect(() => {
    if (!auth.ready) return;
    if (!auth.user) { navigate("/staff/login", { replace: true }); return; }
    if (superadmin && auth.user.role !== "superadmin") { navigate("/staff/kds", { replace: true }); }
  }, [auth.ready, auth.user, navigate, superadmin]);
  return auth;
}
